"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { GlobalStyles } from "./GlobalStyles";
import { Navbar } from "./Navbar";
import { SearchInputHomePage } from "./SearchInputHomePage";
import { Communities } from "./Communities";
import { NavMarketListRowContainer } from "./NavMarketListRowContainer";
import { NavToggleState } from "./NavToggleState";
import { Footer } from "./Footer";

const _interactionsData = JSON.parse(
  '{"events":{"e-123":{"id":"e-123","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-41","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-124"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a69085","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a69085","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1707853020650},"e-125":{"id":"e-125","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-41","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-126"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a6908f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a6908f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1707853020650}},"actionLists":{"a-41":{"id":"a-41","title":"Hero Modal [open]","actionItemGroups":[{"actionItems":[{"id":"a-41-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":"none"}},{"id":"a-41-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-41-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":"flex"}},{"id":"a-41-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1707139287082}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function PageComponentLocations({
  as: _Component = _Builtin.Block,
  stateListSlot,
  stateCollapseSlot,
  mapSlot,
  searchInputSlot,
  toggleSearchButtonProps = {},
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <_Component tag="div">
      <GlobalStyles />
      <_Builtin.Block className="page-wrapper" tag="div">
        <Navbar />
        <_Builtin.Block className="main-wrapper" tag="main" id="main-content">
          <_Builtin.Block className="header" tag="header">
            <_Builtin.Block className="padding-global" tag="div">
              <_Builtin.Block className="container-small" tag="div">
                <_Builtin.Block className="header30_content" tag="div">
                  <_Builtin.Block className="padding-section-large" tag="div">
                    <_Builtin.Block className="text-align-center" tag="div">
                      <_Builtin.Heading className="text-color-white" tag="h1">
                        {"Love Where You Live"}
                      </_Builtin.Heading>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className="header30_background-image-wrapper"
              tag="div"
            >
              <_Builtin.Block className="image-overlay-layer" tag="div" />
              <_Builtin.Image
                className="header30_background-image"
                loading="eager"
                width="auto"
                height="auto"
                fetchPriority="high"
                alt=""
                src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657cb27ed2af154a6fa9d108_Rectangle%2086.jpg"
              />
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className="map" tag="section">
            <_Builtin.Block className="padding-global" tag="div">
              <_Builtin.Block className="container-large" tag="div">
                <_Builtin.Block className="padding-section-large" tag="div">
                  <_Builtin.Grid className="header2_component-copy" tag="div">
                    <_Builtin.Block className="header2_content-copy" tag="div">
                      <_Builtin.Block
                        className="margin-bottom margin-small"
                        tag="div"
                      >
                        <_Builtin.Heading className="heading-5" tag="h2">
                          {"Experience "}
                          <br />
                          <_Builtin.Span className="text-color-blue">
                            {"elevated living"}
                          </_Builtin.Span>
                        </_Builtin.Heading>
                      </_Builtin.Block>
                      <_Builtin.Block className="div-block-90" tag="div">
                        <_Builtin.Paragraph className="max-width-small-copy">
                          {
                            "Spanning numerous locations, we're committed to matching you with the perfect blend of comfort, style, and community, ensuring your search for a new home ends with us."
                          }
                        </_Builtin.Paragraph>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className="margin-top margin-medium"
                        tag="div"
                      >
                        <_Builtin.Link
                          className="link-block-5"
                          button={false}
                          block="inline"
                          options={{
                            href: "#",
                          }}
                          {...toggleSearchButtonProps}
                        >
                          <_Builtin.Block
                            className="fake-form-on-locations-page"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="seach-frame-container-copy"
                              tag="div"
                            >
                              <_Builtin.Block
                                className="text-field-fake"
                                tag="div"
                              >
                                {"Search for a home"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                            <_Builtin.Block
                              className="fake-submit-button-on-locations-page"
                              tag="div"
                            >
                              <_Builtin.Block tag="div">
                                {"Search"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Block
                          className="hero_modal-trigger"
                          tag="div"
                        />
                        <_Builtin.Block
                          className="search_modal___opacity-_0-hide-me"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="search_modal-close-button"
                            tag="div"
                            {...toggleSearchButtonProps}
                          >
                            <_Builtin.HtmlEmbed
                              className="html-embed-4"
                              value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20512%20512%22%3E%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M256%20512A256%20256%200%201%200%20256%200a256%20256%200%201%200%200%20512zM175%20175c9.4-9.4%2024.6-9.4%2033.9%200l47%2047%2047-47c9.4-9.4%2024.6-9.4%2033.9%200s9.4%2024.6%200%2033.9l-47%2047%2047%2047c9.4%209.4%209.4%2024.6%200%2033.9s-24.6%209.4-33.9%200l-47-47-47%2047c-9.4%209.4-24.6%209.4-33.9%200s-9.4-24.6%200-33.9l47-47-47-47c-9.4-9.4-9.4-24.6%200-33.9z%22%2F%3E%3C%2Fsvg%3E"
                            />
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="search_modal-close-trigger"
                            tag="div"
                            {...toggleSearchButtonProps}
                          />
                          <_Builtin.Block
                            className="search-input-slot-container"
                            tag="div"
                          >
                            {searchInputSlot ?? (
                              <SearchInputHomePage
                                showPopover={true}
                                showClear={true}
                              />
                            )}
                          </_Builtin.Block>
                          <_Builtin.Link
                            className="search-modal-close-button"
                            button={false}
                            block="inline"
                            options={{
                              href: "#",
                            }}
                            {...toggleSearchButtonProps}
                          >
                            <_Builtin.Block className="div-block-106" tag="div">
                              <_Builtin.HtmlEmbed
                                className="search-modal-close-icon"
                                value="%3C!--%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20512%20512%22%3E%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M256%20512A256%20256%200%201%200%20256%200a256%20256%200%201%200%200%20512zM175%20175c9.4-9.4%2024.6-9.4%2033.9%200l47%2047%2047-47c9.4-9.4%2024.6-9.4%2033.9%200s9.4%2024.6%200%2033.9l-47%2047%2047%2047c9.4%209.4%209.4%2024.6%200%2033.9s-24.6%209.4-33.9%200l-47-47-47%2047c-9.4%209.4-24.6%209.4-33.9%200s-9.4-24.6%200-33.9l47-47-47-47c-9.4-9.4-9.4-24.6%200-33.9z%22%2F%3E%3C%2Fsvg%3E%0A--%3E%0A%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20384%20512%22%3E%0A%20%20%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M345%20137l17-17L328%2086.1l-17%2017-119%20119L73%20103l-17-17L22.1%20120l17%2017%20119%20119L39%20375l-17%2017L56%20425.9l17-17%20119-119L311%20409l17%2017L361.9%20392l-17-17-119-119L345%20137z%22%2F%3E%3C%2Fsvg%3E"
                              />
                              <_Builtin.Block
                                className="text-block-15"
                                tag="div"
                              >
                                {"Close"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                          </_Builtin.Link>
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className="div-block-43"
                      id="w-node-a8f1e31d-4500-778e-0401-125178d2290d-78d228e3"
                      tag="div"
                    >
                      <_Builtin.Block className="map-wrapper" tag="div">
                        <_Builtin.Block className="div-block-82" tag="div">
                          {mapSlot ?? (
                            <>
                              <_Builtin.HtmlEmbed
                                className="html-embed"
                                value="%3Cdiv%20id%3D%22map%22%20width%3D%221200%22%20height%3D%22739%22%3E%3C%2Fdiv%3E"
                              />
                              <_Builtin.Image
                                className="image-18"
                                loading="lazy"
                                width="auto"
                                height="auto"
                                alt=""
                                src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65d10ac514a8e354f1328e0a_Map.png"
                              />
                            </>
                          )}
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Grid>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <Communities />
          <_Builtin.Block className="text_component" tag="section">
            <_Builtin.Block className="padding-global" tag="div">
              <_Builtin.Block className="container-large" tag="div">
                <_Builtin.Block className="padding-section-large" tag="div">
                  <_Builtin.Grid className="header49_component" tag="div">
                    <_Builtin.Block className="header49_content-left" tag="div">
                      <_Builtin.Heading tag="h2">
                        {"Our Caring Approach"}
                      </_Builtin.Heading>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className="header49_content-right"
                      tag="div"
                    >
                      <_Builtin.Paragraph>
                        {
                          "Dedicated to making life comfortable for our residents since 1993, we offer a wide range of communities in the best neighborhoods throughout Arizona, California, Colorado, Nevada, Texas, and Washington. Our award-winning management team takes pride in creating positive living experiences for everyone in our lively communities."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Grid>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className="text_component-copy" tag="section">
            <_Builtin.Block className="padding-global" tag="div">
              <_Builtin.Block className="container-medium" tag="div">
                <_Builtin.Block className="padding-section-large" tag="div">
                  <_Builtin.Block
                    className="nav-market-list-section-container"
                    tag="div"
                  >
                    <_Builtin.Block
                      className="margin-bottom margin-large"
                      tag="div"
                    >
                      <_Builtin.Block className="text-align-center" tag="div">
                        <_Builtin.Heading tag="h2">
                          {"All Our "}
                          <_Builtin.Span className="text-color-blue">
                            {"Locations"}
                          </_Builtin.Span>
                        </_Builtin.Heading>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className="nav-market-list-section-container"
                      tag="div"
                    >
                      {stateListSlot ?? (
                        <>
                          <NavMarketListRowContainer text="adfsaf" />
                          <NavMarketListRowContainer text="California" />
                          <NavMarketListRowContainer text="Colorado" />
                          <NavMarketListRowContainer text="Nevada" />
                          <NavMarketListRowContainer text="Texas" />
                          <NavMarketListRowContainer text="Washington" />
                        </>
                      )}
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className="text_component-copy" tag="section">
            <_Builtin.Block tag="div">
              {stateCollapseSlot ?? (
                <>
                  <NavToggleState text="Arizona" />
                  <NavToggleState text="CAlifornia" />
                  <NavToggleState />
                  <NavToggleState />
                </>
              )}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <Footer />
      </_Builtin.Block>
    </_Component>
  );
}
